module.exports = __webpack_public_path__ + "images/organization/unlimited-boards.ff264f8aba36fce2e5dc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/organization/unlimited-boards.png
// module id = 5qn2
// module chunks = 12